// extracted by css-extract-rspack-plugin
export default {"wysiwyg":"recommendation-fragment__Wysiwyg_wysiwyg__IaBpx"};